function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { PICKER_MODES } from './constant';
import { getValidDate } from './utils';
import CalendarHeader from './calendar/calendarHeader.js';
export default {
  name: 'MonthYearDecadeCalendar',
  props: {
    prefixCls: {
      type: String,
      default: 'v-calendar'
    },
    mode: {
      type: String,
      default: 'month',
      validator: function validator(v) {
        return ['month', 'year', 'decade'].indexOf(v) > -1;
      }
    },
    value: {
      type: Date,
      default: undefined
    },
    locale: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    format: {
      type: String,
      default: 'YYYY-MM'
    },
    disabledMonth: {
      type: Function,
      default: undefined
    },
    disabledYear: {
      type: Function,
      default: undefined
    },
    monthNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    },
    yearNav: {
      type: Object,
      default: function _default() {
        return {
          prev: true,
          next: true
        };
      }
    }
  },
  data: function data() {
    return {
      innerValue: null,
      innerMode: this.mode
    };
  },
  computed: {
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-month"), true), _defineProperty(_ref, "".concat(prefixCls, "-month-calendar"), true), _ref;
    },
    validMode: function validMode() {
      var mode = this.mode;
      var idx = PICKER_MODES.indexOf(mode);
      var pickerValidModes = PICKER_MODES.slice(idx);
      return pickerValidModes.reduce(function (r, v) {
        var nr = r;
        nr[v] = 1;
        return nr;
      }, {});
    }
  },
  watch: {
    value: function value(nVal) {
      this.setInnerValue(getValidDate(nVal), false);
    }
  },
  created: function created() {
    var value = this.value,
        setInnerValue = this.setInnerValue;
    setInnerValue(getValidDate(value), false);
  },
  methods: {
    setInnerValue: function setInnerValue(val) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var originMode = arguments.length > 2 ? arguments[2] : undefined;
      this.innerValue = val;

      if (trigger) {
        this.$emit('change', val, originMode);
      }
    },
    setInnerMode: function setInnerMode(mode) {
      this.innerMode = mode;
    },
    onChange: function onChange(value, originMode) {
      var mode = this.mode;
      this.setInnerValue(value, originMode === mode, originMode);
    },
    onPanelChange: function onPanelChange(value, next, originMode) {
      var validMode = this.validMode;

      if (next in validMode) {
        this.setInnerMode(next);
        this.$emit('panel-change', value, next, originMode);
      }
    }
  },
  render: function render() {
    var h = arguments[0];
    var $listeners = this.$listeners,
        prefixCls = this.prefixCls,
        classes = this.classes,
        format = this.format,
        innerMode = this.innerMode,
        innerValue = this.innerValue,
        locale = this.locale,
        disabledMonth = this.disabledMonth,
        disabledYear = this.disabledYear,
        monthNav = this.monthNav,
        yearNav = this.yearNav,
        onChange = this.onChange,
        onPanelChange = this.onPanelChange;

    var on = _objectSpread({}, $listeners, {
      change: onChange,
      'panel-change': onPanelChange
    });

    return h("div", {
      "class": classes
    }, [h("div", {
      "class": "".concat(prefixCls, "-month-calendar-content")
    }, [h("div", {
      "class": "".concat(prefixCls, "-month-header-wrap")
    }, [h(CalendarHeader, {
      "props": _objectSpread({}, {
        prefixCls: prefixCls,
        format: format,
        mode: innerMode,
        value: innerValue,
        locale: locale,
        disabledMonth: disabledMonth,
        disabledYear: disabledYear,
        monthNav: monthNav,
        yearNav: yearNav
      }),
      "on": _objectSpread({}, on)
    })])])]);
  }
};